<template>
  <div id="mobileMenuBar">
    <div class="toggle-hamburger clickable" @click="expand" @keypress.enter="expand">
      <div class="hamburger-line" />
      <div class="hamburger-line" />
      <div class="hamburger-line" />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    expand() {
      this.$emit('expand');
    },
  },
};
</script>
